import { LDClient } from 'launchdarkly-js-client-sdk'
import React from 'react'
import { FeatureFlagConfig } from '../App/app.api'
import { User } from '../Permissions/AuthenticatedUser.context'
import * as consts from './featureFlags.constants'

export interface FeatureFlagsContextType {
  user: User | null,
  launchDarklyProps: FeatureFlagConfig | null,
  featureFlagClient: LDClient | null,
}

const FeatureFlagsContext = React.createContext<FeatureFlagsContextType>({
  user: null,
  launchDarklyProps: { 'implementation': consts.UNLOADED_IMPLEMENTATION },
  featureFlagClient: null,
})

export default FeatureFlagsContext
